export default function MuiInputBase(theme: any) {
  return {
    MuiInputBase: {
      variants: [
        {
          props: { variant: "outlined" },
          style: {},
        },
      ],
      styleOverrides: {
        root: {
          "& input": {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            paddingLeft: theme.spacing(2.75),
            paddingRight: theme.spacing(2.75),

          },
          "& input + fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.grey[500],
          },
          "&:hover input + .MuiOutlinedInput-notchedOutline, &:hover input + .MuiInputAdornment-root + .MuiOutlinedInput-notchedOutline":
          {
            border: `1px solid ${theme.palette.grey[0]}`,
          },

          "&.Mui-focused .MuiInputBase-input + .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiInputBase-input  + .MuiInputAdornment-root + .MuiOutlinedInput-notchedOutline":
          {
            border: `1px solid ${theme.palette.grey[0]}`,
          },
          "&.Mui-focused.Mui-error .MuiInputBase-input + .MuiOutlinedInput-notchedOutline, &.Mui-focused.Mui-error input + .MuiInputAdornment-root + .MuiOutlinedInput-notchedOutline":
          {
            border: `1px solid ${theme.palette.error.main}`,
          },

          "&.Mui-error:hover input +  .MuiOutlinedInput-notchedOutline, &.Mui-error:hover input + .MuiInputAdornment-root + .MuiOutlinedInput-notchedOutline":
          {
            border: `1px solid ${theme.palette.error.main}`,
          },
          "&.Mui-error.Mui-focused:hover .MuiInputBase-input +  .MuiOutlinedInput-notchedOutline, &.Mui-error.Mui-focused:hover .MuiInputBase-input + .MuiInputAdornment-root + .MuiOutlinedInput-notchedOutline":
          {
            border: `1px solid ${theme.palette.error.main}`,
          },
          "& .MuiSelect-select ~ .MuiOutlinedInput-notchedOutline": {
            borderWidth: "1px",
            borderColor: theme.palette.grey[500],
            transition: "all .3s ease-in-out",
          },
          "&.Mui-focused .MuiSelect-select ~.MuiOutlinedInput-notchedOutline": {
            borderWidth: "1px",
          },
          "&.MuiInputBase-hiddenLabel fieldset.MuiOutlinedInput-notchedOutline legend":
          {
            display: "none",
          },
        },
      },
    },
  };
}
